export default "__VITE_ASSET__DFVQgtVz__"